import { render } from "./studioAchievement.vue?vue&type=template&id=ff40d41e&scoped=true"
import script from "./studioAchievement.vue?vue&type=script&lang=js"
export * from "./studioAchievement.vue?vue&type=script&lang=js"

import "./studioAchievement.vue?vue&type=style&index=0&id=ff40d41e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff40d41e"]])

export default __exports__